import { Transform, Expose, ExposeOptions, TransformOptions } from 'class-transformer';
import { get, isNil } from 'lodash';

export function Default(defaultValue: any): (target: any, key: string) => void {
  return Transform((value: any) => (isNil(value) ? defaultValue : value), { toClassOnly: true });
}

export function ExposeRawData(
  options?: TransformOptions & ExposeOptions & { default?: any },
): (target: any, key: string) => void {
  return (target: any, key: string) => {
    const defaultValue = options && options.default;
    const name = (options && options.name) || key;

    const expose = Expose({
      toClassOnly: true,
      ...options,
      name: `__${name}__`,
    });

    const transform = Transform((value, data) => (isNil(data[name]) ? defaultValue : data[name]), {
      toClassOnly: true,
      ...options,
    });

    expose(target, key);
    transform(target, key);
  };
}

export function Plunk(key: string, options?: TransformOptions): (target: any, key: string) => void {
  return Transform((value) => get(value, key), { toPlainOnly: true, ...options });
}

export function PlunkArray(
  key: string,
  options?: TransformOptions,
): (target: any, key: string) => void {
  return Transform((value) => (!value ? [] : value.map((item) => item[key])), {
    toPlainOnly: true,
    ...options,
  });
}

export function ExposeFunction(
  options?: TransformOptions & ExposeOptions,
): (target: any, key: string) => void {
  return (target: any, key: string) => {
    const name = (options && options.name) || key;

    const expose = Expose({
      toClassOnly: true,
      ...options,
      name: `__${name}__`,
    });

    const transform = Transform(
      (_, data) => {
        const value = data[name];
        return typeof value === 'function' ? value : () => value;
      },
      { toClassOnly: true, ...options },
    );

    expose(target, key);
    transform(target, key);
  };
}
